module.exports = __webpack_public_path__ + "media/country_flags/ly-65f21ac3.png";